let $ = require("jquery");
let _ = require("underscore");
let moment = require('moment');
let Backbone = require("backbone");
let DbRecorder = require("../recorder/DbRecorder.js");
import CloudPrintUtils from "../service/CloudPrintUtils.js";
import i18n from "./i18n";
import POS from "../POS.js";

let main = function ($, _, Backbone, DbRecorder, i18n, POS) {
    return (function () {
            var PrinterConverterUtil = {};
            var defaultPrintTimeInterval = 60 * 1000;
            var fullCode = function (code) {
                return "pos.printer.receipt." + code;
            };
            var leftBracket = 40, rightBracket = 41,
                leftMidBracket = 91, rightMidBracket = 93,
                comma = 44, space = 32, asterisk = 42;

            var sidText = function (bill) {
                if (!bill.shortUUID) {
                    return bill.sid;
                }

                if (bill.sid == bill.shortUUID) {
                    return bill.sid;
                } else {
                    return bill.sid + " (" + bill.shortUUID + ")";
                }
            };
            var refundBytes = function (value, bytes) {
                var array = [];
                for (var i = 0; i < value.length; i++) {
                    array.push(value.charCodeAt(i));
                }
                array.push("(".charCodeAt(0));
                array = array.concat(bytes);
                array.push(")".charCodeAt(0));
                return array;
            };

            var serialBytes = function (value, bytes) {
                var array = [];
                array = array.concat(bytes);
                for (var i = 0; i < value.length; i++) {
                    array.push(value.charCodeAt(i));
                }
                return array;
            };

            var serialData = function (bill) {
                var user = POS.getUser(), serial = {};
                if (user.staffNo) {
                    serial.text = user.staffNo + bill.serial;
                    serial.bytes = serialBytes(bill.serial.toString(), user.bytesmap.staffNo.valuebytes.bytes);

                } else {
                    serial.text = bill.serial;
                }
                return serial;
            };

            var buildQrcode = function (bill) {
                var qrcode = {format: 'center', items: bill.qrcode};
                return qrcode
            };

            var orderNum = function (bill) {
                var sid = {};
                if (bill.sid) {
                    sid.text = bill.sid.toString().substring(8);
                    return sid
                }
                return sid
            };

            var buildSerial = function (bill) {
                var summary = {format: 'left_right_s', items: []}, item;
                item = {
                    left: {font: "large", value: POS.getCodeBytes(fullCode("serial"))},
                    right: {font: "large", value: orderNum(bill)}
                };
                summary.items.push(item);
                return summary;
            };
            var buildOrderSummary = function (bill, flag) {
                var summary = {format: 'left_right_s', items: []}, item, shouldPayAmount = bill.shouldPayAmount;
                item = {
                    left: {value: POS.getCodeBytes(fullCode("order.amount.label"))},
                    right: {value: {text: bill.orderAmount.toFixed(2)}}
                };
                summary.items.push(item);
                if (bill.feeAmount != 0 && !(bill.noFee || bill.shippingRecord)) {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode("feeAmount"))},
                        right: {value: {text: (bill.feeAmount).toFixed(2)}}
                    };
                    summary.items.push(item);
                }
                if (bill.postageAmount > 0) {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode("postage.amount.label"))},
                        right: {value: {text: bill.postageAmount.toFixed(2)}}
                    };
                    summary.items.push(item);
                }
                if (bill.refundStatus == "Total" || bill.refundStatus == "Has") {
                    if (bill.offDiscountAmount != 0) {
                        item = {
                            left: {value: POS.getCodeBytes(fullCode("discount.amount.label"))},
                            right: {value: {text: (0 - bill.offDiscountAmount).toFixed(2)}}
                        };
                        summary.items.push(item);
                    }
                } else {
                    if (bill.offDiscountAmount != 0) {
                        item = {
                            left: {value: POS.getCodeBytes(fullCode("discount.amount.label"))},
                            right: {value: {text: (0 - bill.offDiscountAmount).toFixed(2)}}
                        };
                        summary.items.push(item);
                    }
                }
                if (bill.ignoreAmount != 0) {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode("payment.IGNORE.label"))},
                        right: {value: {text: (0 - bill.ignoreAmount).toFixed(2)}}
                    };
                    summary.items.push(item);
                }
                if (bill.tipAmount != 0) {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode("payment.TIP.label"))},
                        right: {value: {text: bill.tipAmount.toFixed(2)}}
                    };
                    summary.items.push(item);
                }
                var refundAmount = 0, hasRefund = false;
                _.each(bill.items, function (item) {
                    var paidQuantity = item.refundQuantity - item.unPaidRefundQuantity;
                    if (item.hasRefund && item.paid && paidQuantity > 0) {
                        hasRefund = true;
                        refundAmount += (item.discountedPrice ? item.discountedPrice : item.price) * paidQuantity;
                    }
                });
                if (hasRefund) {
                    refundAmount = refundAmount + bill.tipAmount;
                }
                if (bill.pingRefund) {
                    refundAmount = bill.pingPayAmount / 100;
                }
                if (refundAmount != 0) {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode("refundAmount"))},
                        right: {value: {text: (refundAmount).toFixed(2)}}
                    };
                    summary.items.push(item);
                }
                if (shouldPayAmount <= 0) {
                    shouldPayAmount = bill.originalShouldPayAmount;
                }
                shouldPayAmount = shouldPayAmount;
                item = {
                    left: {font: "large", value: POS.getCodeBytes(fullCode("should.pay.amount.label"))},
                    right: {font: "large", value: {text: shouldPayAmount}}
                };
                summary.items.push(item);
                return summary;
            };

            var buildCustomerContent = function () {
                var restaurant = DbRecorder.convert2JSON(POS.getRestaurant());
                if (restaurant.bytesmap.customerContent) {
                    var data = restaurant.bytesmap.customerContent.valuebytes;
                    return {format: "title", value: data, font: "normal"};
                }
                return null;
            };

            var buildLineFeed = function () {
                return {format: "line_feed"};
            };

            var buildRePrintInfo = function (bill, type) {
                var result = {}, data = {
                    bytes: [],
                    text: "",
                };
                let count = bill.billRePrint[type];
                count = ++count;
                var strHead = POS.getCodeBytes(fullCode("reprint.head"));
                var strFoot = POS.getCodeBytes(fullCode("reprint.foot"));
                data.bytes.push(asterisk);
                data.bytes.push(asterisk);
                data.text += "*";
                data.text += "*";
                data.bytes = data.bytes.concat(strHead.bytes);
                data.text += strHead.text;
                data.text += count.toString();
                _.each(count.toString(), function (code) {
                    data.bytes.push(code.charCodeAt(0));
                });
                data.bytes = data.bytes.concat(strFoot.bytes);
                data.text += strFoot.text;
                data.bytes.push(asterisk);
                data.bytes.push(asterisk);
                data.text += "*";
                data.text += "*";
                return {format: "title", value: data}
            };

            var buildShippingSummary = function (bill, leadline) {
                var summary = {
                    format: 'left_right_s',
                    items: [],
                    noLeadLine: leadline
                }, record = bill.shippingRecord, item;
                item = {
                    left: {value: POS.getCodeBytes(fullCode("shipping.consignee.label"))},
                    right: {value: record.bytesmap.consignee.valuebytes}
                };
                summary.items.push(item);
                item = {
                    left: {value: POS.getCodeBytes(fullCode("shipping.phone.label"))},
                    right: {value: record.bytesmap.phone.valuebytes}
                };
                summary.items.push(item);
                if (record.bytesmap.address) {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode("shipping.address.label"))},
                        right: {value: record.bytesmap.address.valuebytes}
                    };
                    summary.items.push(item);
                }
                if (record.bytesmap.note) {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode("shipping.note.label"))},
                        right: {value: record.bytesmap.note.valuebytes}
                    };
                    summary.items.push(item);
                }

                return summary;
            };

            var buildBillHeader = function (bill) {
                var map = {format: "map", items: []}, user = POS.getUser(),
                    restaurant = DbRecorder.convert2JSON(POS.getRestaurant()), item;
                console.log('printer user info', user);
                map.items = [];
                item = {
                    key: POS.getCodeBytes(fullCode("restaurant.name.label")),
                    value: restaurant.bytesmap.name.valuebytes
                };
                map.items.push(item);
                item = {
                    key: POS.getCodeBytes(fullCode("time.label")),
                    value: {text: new moment().format('HH:mm')}
                };
                map.items.push(item);
                item = {key: POS.getCodeBytes(fullCode("bill.sid")), value: {text: sidText(bill)}};
                map.items.push(item);
                item = {key: POS.getCodeBytes(fullCode("diner.count.label")), value: {text: bill.dinerCount}};
                map.items.push(item);
                item = {
                    key: POS.getCodeBytes(fullCode("table.name.label")),
                    value: bill.table.bytesmap.name.valuebytes
                };
                map.items.push(item);
                item = {
                    key: POS.getCodeBytes(fullCode("operator.name.label")),
                    value: user.bytesmap.fullname ? user.bytesmap.fullname.valuebytes : user.bytesmap.name.valuebytes
                };
                map.items.push(item);
                if (bill.note && bill.noteBytes) {
                    item = {
                        key: POS.getCodeBytes(fullCode("note.label")),
                        value: {text: bill.note, bytes: bill.noteBytes}
                    };
                    map.items.push(item);
                }
                return map;
            };

            var buildBillItemTable = function (bill, flag) {
                var table = {format: "table", flexIndex: 1, size: 5}, item, header, tr, menuItem, menuBytes;
                header = {items: []};
                item = {value: POS.getCodeBytes(fullCode("order.label"))};
                header.items.push(item);
                item = {value: POS.getCodeBytes(fullCode("menu.item.label"))};
                header.items.push(item);
                item = {value: POS.getCodeBytes(fullCode("quantity.label"))};
                header.items.push(item);
                item = {value: POS.getCodeBytes(fullCode("price.unit.label"))};
                header.items.push(item);
                item = {value: POS.getCodeBytes(fullCode("amount.label"))};
                header.items.push(item);
                table.header = header;
                table.body = {trs: []};
                var items = flag ? bill.uitems : bill.items;
                var packIndex = 1;
                _.each(items, function (bi, index) {
                    tr = {items: []};
                    if (bi.hasRefund) {
                        item = {
                            value: {
                                text: (packIndex) + "(" + POS.getCodeBytes(fullCode("refund.label")).text + ")",
                                bytes: refundBytes((packIndex).toString(), POS.getCodeBytes(fullCode("refund.label")).bytes)
                            }
                        };
                    } else {
                        item = {value: {text: packIndex}};
                    }
                    tr.items.push(item);
                    menuBytes = POS.getMenuItemBytes(bi.menuItem.id).name.valuebytes;
                    if (bi.packageId && bi.packageOptionName) {
                        var packBytes = {
                            bytes: [],
                            text: ""
                        };
                        menuBytes = JSON.stringify(menuBytes);
                        menuBytes = JSON.parse(menuBytes);
                        packBytes.bytes.push(leftBracket);
                        packBytes.text += "(";
                        packBytes.bytes = packBytes.bytes.concat(POS.getCodeBytes(fullCode("package")).bytes);
                        packBytes.text += "套";
                        packBytes.bytes.push(rightBracket);
                        packBytes.text += ")";
                        packBytes.bytes = packBytes.bytes.concat(menuBytes.bytes);
                        packBytes.text += menuBytes.text;
                        menuBytes = packBytes
                    }
                    if (bi.tags && bi.tags.length > 0) {
                        menuBytes = JSON.stringify(menuBytes);
                        menuBytes = JSON.parse(menuBytes);
                        menuBytes.bytes.push(leftBracket);
                        menuBytes.text += "(";
                        _.each(bi.tags, function (tag, index) {
                            if ((index + 1) == bi.tags.length) {
                                menuBytes.bytes = menuBytes.bytes.concat(POS.getTagsBytes(tag.id));
                                menuBytes.text += tag.name;
                            } else {
                                menuBytes.bytes = menuBytes.bytes.concat(POS.getTagsBytes(tag.id));
                                menuBytes.text += tag.name;
                                menuBytes.bytes.push(comma);
                                menuBytes.text += ",";
                            }
                        });
                        menuBytes.bytes.push(rightBracket);
                        menuBytes.text += ")";
                    }
                    item = {value: menuBytes};
                    tr.items.push(item);
                    item = {value: {text: bi.orderedQuantity}};
                    tr.items.push(item);
                    item = {value: {text: parseFloat(bi.price).toFixed(2)}};
                    tr.items.push(item);
                    item = {value: {text: ((bi.discountedPrice ? bi.discountedPrice : bi.price) * (bi.quantity - bi.refundQuantity)).toFixed(2)}};
                    tr.items.push(item);
                    table.body.trs.push(tr);
                    packIndex++;
                });
                return table;
            };

            var buildMembership = function (bill) {
                var summary = {format: 'left_right_s', items: []}, membership = bill.membership, item;
                item = {
                    left: {value: POS.getCodeBytes(fullCode("membership.no.label"))},
                    right: {value: membership.bytesmap.cardNo.valuebytes}
                };
                summary.items.push(item);
                item = {
                    left: {value: POS.getCodeBytes(fullCode("membership.name.label"))},
                    right: {value: membership.bytesmap.fullname.valuebytes}
                };
                summary.items.push(item);
                _.each(membership.credit, function (credit, index) {
                    item = {
                        left: {value: bill.membership.bytesmap.credit.valuebytes[index].currency.valuebytes},
                        right: {value: {text: credit.credit.toFixed(2)}}
                    };
                    summary.items.push(item);
                });
                return summary;
            };

            var buildPayments = function (bill) {
                var summary = {
                    format: 'left_right_s',
                    items: []
                }, payments = [], payAmount = 0, payment, item, orderAmount = 0, changeAmount = 0;
                _.each(bill.payments, function (p) {
                    if (p.type == "Change" && p.method == "CASH") {
                        changeAmount += p.amount;
                    }
                    payment = _.findWhere(payments, {method: p.method});
                    if (p.type != "Change" || p.type != "Refund") {
                        if (payment) {
                            payment.amount += p.amount;
                        } else {
                            payments.push(p);
                        }
                    }
                });
                _.each(payments, function (payment) {
                    if (payment.amount != 0) {
                        if (payment.method != 'IGNORE' && payment.method != 'ROUND' && payment.method != 'TIP') {
                            if (payment.type != "Refund" && payment.type != 'Change') {
                                var methodName = POS.getCodeBytes(fullCode("payment." + payment.method + ".label"));
                                if (payment.method == 'MEMBER_CARD') {
                                    methodName = payment.currency.bytesmap.name.valuebytes;
                                }
                                if (payment.customPayment) {
                                    methodName = payment.customPayment.bytesmap.name.valuebytes
                                }
                                item = {
                                    left: {value: methodName},
                                    right: {value: {text: payment.original.toFixed(2)}}
                                };
                                summary.items.push(item);
                            }
                        }
                        if (payment.type != 'Change' && payment.type != "Refund") {
                            if (payment.method == "TIP") {
                                orderAmount = orderAmount - payment.amount;
                            } else if (payment.method == "IGNORE") {
                                orderAmount = orderAmount + payment.amount;
                            } else if (payment.method == "ROUND") {
                                orderAmount = orderAmount + payment.amount;
                            } else {
                                orderAmount = orderAmount + payment.amount;
                                payAmount += payment.amount;
                            }
                        }
                    }
                });
                if (Math.abs(changeAmount) > 0) {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode("payment.CHANGE.label"))},
                        right: {value: {text: changeAmount.toFixed(2)}}
                    };
                    summary.items.push(item);
                } else if (payAmount - bill.originalShouldPayAmount > 0) {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode("payment.CHANGE.label"))},
                        right: {value: {text: (bill.originalShouldPayAmount.toFixed(2) - payAmount).toFixed(2)}}
                    };
                    summary.items.push(item);
                }
                return summary;
            };

            var toTagReceipt = PrinterConverterUtil.toTagReceipt = function (bill, billItem) {
                var result = {}, data = [], summary, item, quantity,
                    user = POS.getUser(), tags = [],
                    menuBytes,
                    tagStore = POS.get("printerTags");
                _.each(tagStore, function (tag) {
                    if (_.some(tag.itemIds, function (itemId) {
                            return billItem.menuItem.id == itemId;
                        })) {
                        tags.push(tag.name);
                    } else if (_.some(tag.categoryIds, function (cateId) {
                            return billItem.menuItem.categoryId == cateId;
                        })) {
                        tags.push(tag.name);
                    }
                });
                if (tags.length == 0) {
                    tags.push("tooie_reserved");
                }
                //if (billItem.status == "Completed") {
                //    return null;
                //}
                summary = {format: 'tag_title', items: []};
                item = {
                    left: {value: POS.getCodeBytes(fullCode("serial"))},
                    right: {value: serialData(bill)}
                };
                summary.items.push(item);
                data.push(summary);
                summary = {format: 'tag_title', items: []};
                item = {
                    left: {value: POS.getCodeBytes(fullCode("table.name.label"))},
                    right: {value: bill.table.bytesmap.name.valuebytes}
                };
                summary.items.push(item);
                data.push(summary);
                summary = {format: 'tag_title', items: []};
                item = {
                    left: {value: POS.getCodeBytes(fullCode("bill.sid"))},
                    right: {value: {text: bill.sid}}
                };
                summary.items.push(item);
                data.push(summary);
                summary = {format: 'tag_content', items: []};
                item = {
                    content: {value: POS.getMenuItemBytes(billItem.menuItem.id).name.valuebytes}
                };
                summary.items.push(item);
                data.push(summary);
                summary = {format: 'tag_tags', items: []};
                if (billItem.tags && billItem.tags.length > 0) {
                    _.each(billItem.tags, function (tag, index) {
                        summary.items.push(POS.getTagsBytes(tag.id));
                    });
                }
                data.push(summary);
                result.data = data;
                result.tags = tags;
                result.type = "TagItem";
                return result;
            };

            var toEachItemReceipt = PrinterConverterUtil.toEachItemReceipt = function (bill, billItem, type, packageItem, rePrint, refundQuantity) {
                console.log(bill, billItem, type);
                var result = {}, data = [], summary, item, quantity,
                    user = POS.getUser(), tags = [],
                    menuBytes,
                    tagStore = POS.get("printerTags");
                _.each(tagStore, function (tag) {
                    if (_.some(tag.itemIds, function (itemId) {
                            return billItem.menuItem.id == itemId;
                        })) {
                        tags.push(tag.name);
                    } else if (_.some(tag.categoryIds, function (cateId) {
                            return billItem.menuItem.categoryId == cateId;
                        })) {
                        tags.push(tag.name);
                    }
                });
                if (tags.length == 0) {
                    tags.push("tooie_reserved");
                }
                summary = {format: 'left_right_s', items: [], noLeadLine: false};
                switch (type) {
                    case "RefundItem":
                        data.push({format: "title", value: POS.getCodeBytes(fullCode("refund.receipt.title"))});
                        quantity = billItem.refundQuantity;
                        if (quantity === 0) {
                            return null;
                        }
                        break;
                    case "RefundAmount":
                        data.push({format: "title", value: POS.getCodeBytes(fullCode("refund.amount.title"))});
                        quantity = billItem.refundQuantity;
                        if (quantity === 0) {
                            return null;
                        }
                        break;
                    case "ReEachItem":
                        quantity = billItem.orderedQuantity;
                        if (quantity === 0) {
                            return null;
                        }
                        data.push({
                            format: "title",
                            value: POS.getCodeBytes(fullCode("each.item.recall.receipt.title"))
                        });
                        break;
                    default:
                        summary.noLeadLine = true;
                        quantity = billItem.orderedQuantity;
                        if (quantity === 0) {
                            return null;
                        }
                        if (billItem.orderStatus == "urge") {
                            data.push({
                                format: "title",
                                value: POS.getCodeBytes(fullCode("each.item.recall.receipt.title"))
                            });
                        } else if (billItem.orderStatus == "wait") {
                            data.push({
                                format: "title",
                                value: POS.getCodeBytes(fullCode("urge.item.recall.receipt.title"))
                            });
                        }
                        break;
                }
                data.push({format: "title", value: bill.table.bytesmap.name.valuebytes});
                data.push({
                    format: "title", value: {
                        text: bill.orderDate == 0 ? new moment().format('HH:mm') : new moment(bill.orderDate).format('HH:mm'),
                    }
                });
                summary = {format: 'left_right_s', items: []};
                if (type != "RefundAmount") {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode("category"))},
                        right: {value: POS.getMenuCatBytes(billItem.menuItem.categoryId).name.valuebytes}
                    };
                    summary.items.push(item);
                }
                if (type == "RefundAmount") {
                    var refundAmount = billItem.discountedPrice ? billItem.discountedPrice : billItem.price * billItem.refundQuantity;
                    item = {
                        left: {value: POS.getCodeBytes(fullCode("refundAmount"))},
                        right: {value: {text: refundAmount.toFixed(2)}}
                    };
                    summary.items.push(item);
                }
                item = {
                    left: {value: POS.getCodeBytes(fullCode("operator.name.label"))},
                    right: {value: user.bytesmap.fullname ? user.bytesmap.fullname.valuebytes : user.bytesmap.name.valuebytes}
                };
                summary.items.push(item);
                item = {
                    left: {value: POS.getCodeBytes(fullCode("bill.sid"))},
                    right: {value: {text: sidText(bill)}}
                };
                summary.items.push(item);
                if (bill.note && bill.noteBytes) {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode("note.label"))},
                        right: {value: {text: bill.note, bytes: bill.noteBytes}}
                    };
                    summary.items.push(item);
                }
                data.push(summary);
                if (bill.table.multiple) {
                    data.push(buildShippingSummary(bill, true));
                }
                summary = {format: 'left_right_s', items: []};

                menuBytes = POS.getMenuItemBytes(billItem.menuItem.id).name.valuebytes;
                if (billItem.packageId && billItem.packageOptionName) {
                    var packBytes = {
                        bytes: [],
                        text: ""
                    };
                    menuBytes = JSON.stringify(menuBytes);
                    menuBytes = JSON.parse(menuBytes);
                    packBytes.bytes.push(leftBracket);
                    packBytes.text += "(";
                    packBytes.bytes = packBytes.bytes.concat(POS.getCodeBytes(fullCode("package")).bytes);
                    packBytes.text += "套";
                    packBytes.bytes.push(rightBracket);
                    packBytes.text += ")";
                    packBytes.bytes = packBytes.bytes.concat(menuBytes.bytes);
                    packBytes.text += menuBytes.text;
                    menuBytes = packBytes
                }
                if (billItem.tags && billItem.tags.length > 0) {
                    menuBytes = JSON.stringify(menuBytes);
                    menuBytes = JSON.parse(menuBytes);
                    menuBytes.bytes.push(leftBracket);
                    menuBytes.text += "(";
                    _.each(billItem.tags, function (tag, index) {
                        if (index + 1 == billItem.tags.length) {
                            menuBytes.bytes = menuBytes.bytes.concat(POS.getTagsBytes(tag.id));
                            menuBytes.text += tag.name;
                        } else {
                            menuBytes.bytes = menuBytes.bytes.concat(POS.getTagsBytes(tag.id));
                            menuBytes.text += tag.name;
                            menuBytes.bytes.push(comma);
                            menuBytes.text += ",";
                        }
                    });
                    menuBytes.bytes.push(rightBracket);
                    menuBytes.text += ")";
                }
                quantity = {text: refundQuantity ? refundQuantity : billItem.quantity};
                var unit = POS.getMenuItemBytes(billItem.menuItem.id);
                if (unit.itemUnit) {
                    var unitBytesMap = unit.itemUnit.valuebytes;
                    var text = "";
                    var bytes = [];
                    text += refundQuantity ? refundQuantity.toString() : billItem.quantity.toString();
                    text += unitBytesMap.text;
                    _.each(refundQuantity ? refundQuantity.toString() : billItem.quantity.toString(), function (code) {
                        bytes.push(code.charCodeAt(0));
                    });
                    bytes = bytes.concat(unitBytesMap.bytes);
                    quantity = {
                        text: text,
                        bytes: bytes
                    }
                }
                item = {
                    left: {font: "large", value: menuBytes},
                    right: {font: "large", value: quantity}
                };
                summary.items.push(item);
                data.push(summary);
                if (rePrint) {
                    data.push(buildRePrintInfo(bill, !type ? "EachItem" : type))
                }
                result.data = data;
                result.tags = tags;
                result.type = !type ? "EachItem" : type;
                return result;
            };

            var toEachItemReceipts = PrinterConverterUtil.toEachItemReceipts = function (bill, type, flag, rePrint) {
                var items = flag ? bill.uitems : bill.items, data = [], self = this;
                _.each(items, function (billItem) {
                    if (!billItem.billItemModelId) {
                        var result = toEachItemReceipt(bill, billItem, type, null, rePrint);
                        if (result) {
                            result.bill = bill.sid ? bill.sid + "(" + bill.shortUUID + ")" : bill.shortUUID;
                            CloudPrintUtils._cloudPrint({
                                type: "EachItem",
                                data: result,
                                bill: bill.sid ? bill.sid + "(" + bill.shortUUID + ")" : bill.shortUUID
                            });
                            data.push(result);
                        }
                    }
                });
                return data;
            };

            var toTagReceipts = PrinterConverterUtil.toTagReceipts = function (bill, type, flag) {
                var items = flag ? bill.uitems : bill.items, data = [];
                _.each(items, function (billItem) {
                    if (!billItem.hasRefund) {
                        if (!billItem.billItemModelId) {
                            for (var x = 0; x < billItem.quantity; x++) {
                                data.push(toTagReceipt(bill, billItem));
                            }
                        }
                    }
                });
                return data;
            };

            var toDispatchReceipt = PrinterConverterUtil.toDispatchReceipt = function (bill, type, flag, rePrint) {
                var billItems = flag ? bill.uitems : bill.items;
                var result = {}, data = [], items = [], collapsed, summary, item, line, map, menuBytes;
                var tagStore = POS.get("printerTags");
                var user = POS.getUser();
                data.push({format: "title", value: POS.getCodeBytes(fullCode("dispatch.receipt.title"))});
                data.push({format: "title", value: bill.table.bytesmap.name.valuebytes});
                data.push({
                    format: "title",
                    value: {text: bill.orderDate == 0 ? new moment().format('HH:mm') : new moment(bill.orderDate).format('HH:mm')}
                });
                line = {format: "left_right_s", items: []};
                item = {
                    left: {value: POS.getCodeBytes(fullCode("operator.name.label"))},
                    right: {value: user.bytesmap.fullname ? user.bytesmap.fullname.valuebytes : user.bytesmap.name.valuebytes}
                };
                line.items.push(item);
                data.push(line);
                map = {format: "map", items: []};
                item = {key: POS.getCodeBytes(fullCode("serial")), value: serialData(bill)};
                map.items.push(item);
                item = {key: POS.getCodeBytes(fullCode("bill.sid")), value: {text: sidText(bill)}};
                map.items.push(item);
                if (bill.note && bill.noteBytes) {
                    item = {key: POS.getCodeBytes(fullCode("note.label")), value: {text: bill.note, bytes: bill.noteBytes}};
                    map.items.push(item);
                }
                data.push(map);
                _.each(billItems, function (item) {
                    switch (type) {
                        case "ReDisPatch":
                            break;
                        default:
                            if (item["dispatchPrinted"]) {
                                return false;
                            }
                            break;
                    }
                    if (item.orderedQuantity < 1) {
                        return false;
                    }
                    if (item.billItemModelId) {
                        return false;
                    }
                    collapsed = _.find(items, function (col) {
                        if (col.tags || item.tags) {
                            return false;
                        }
                        if (item.packageId && item.packageOptionName) {
                            return (col.menuItem.id == item.menuItem.id) && (item.packageId == col.packageId);
                        }
                        return col.menuItem.id == item.menuItem.id;
                    });
                    if (collapsed) {
                        collapsed.quantity += item.orderedQuantity;
                    } else {
                        var params = {menuItem: item.menuItem, quantity: item.orderedQuantity, tags: item.tags};
                        if (item.packageId && item.packageOptionName) {
                            params["packageId"] = item.packageId
                        }
                        items.push(params);
                    }
                    return true;
                });
                _.each(items, function (billItem) {
                    var tags = [];
                    summary = {format: 'left_right_s', items: []};
                    item = {
                        left: {value: POS.getCodeBytes(fullCode("category"))},
                        right: {value: POS.getMenuCatBytes(billItem.menuItem.categoryId).name.valuebytes}
                    };
                    summary.items.push(item);

                    menuBytes = POS.getMenuItemBytes(billItem.menuItem.id).name.valuebytes;
                    if (billItem.packageId) {
                        var packBytes = {
                            bytes: [],
                            text: ""
                        };
                        menuBytes = JSON.stringify(menuBytes);
                        menuBytes = JSON.parse(menuBytes);
                        packBytes.bytes.push(leftBracket);
                        packBytes.text += "(";
                        packBytes.bytes = packBytes.bytes.concat(POS.getCodeBytes(fullCode("package")).bytes);
                        packBytes.text += "套";
                        packBytes.bytes.push(rightBracket);
                        packBytes.text += ")";
                        packBytes.bytes = packBytes.bytes.concat(menuBytes.bytes);
                        packBytes.text += menuBytes.text;
                        menuBytes = packBytes
                    }
                    if (billItem.tags && billItem.tags.length > 0) {
                        menuBytes = JSON.stringify(menuBytes);
                        menuBytes = JSON.parse(menuBytes);
                        menuBytes.bytes.push(leftBracket);
                        menuBytes.text += "(";
                        _.each(billItem.tags, function (tag, index) {
                            if (index + 1 == billItem.tags.length) {
                                menuBytes.bytes = menuBytes.bytes.concat(POS.getTagsBytes(tag.id));
                                menuBytes.text += tag.name;
                            } else {
                                menuBytes.bytes = menuBytes.bytes.concat(POS.getTagsBytes(tag.id));
                                menuBytes.text += tag.name;
                                menuBytes.bytes.push(comma);
                                menuBytes.text += ",";
                            }
                        });
                        menuBytes.bytes.push(rightBracket);
                        menuBytes.text += ")";
                    }
                    var quantity = {text: billItem.quantity};
                    var unit = POS.getMenuItemBytes(billItem.menuItem.id);
                    if (unit.itemUnit) {
                        var unitBytesMap = unit.itemUnit.valuebytes;
                        var text = "";
                        var bytes = [];
                        text += billItem.quantity.toString();
                        text += unitBytesMap.text;
                        _.each(billItem.quantity.toString(), function (code) {
                            bytes.push(code.charCodeAt(0));
                        });
                        bytes = bytes.concat(unitBytesMap.bytes);
                        quantity = {
                            text: text,
                            bytes: bytes
                        }
                    }
                    item = {
                        left: {font: "large", value: menuBytes},
                        right: {font: "large", value: quantity}
                    };
                    _.each(tagStore, function (tag) {
                        if (_.some(tag.itemIds, function (itemId) {
                                return billItem.menuItem.id == itemId;
                            })) {
                            tags.push(tag.name);
                        } else if (_.some(tag.categoryIds, function (cateId) {
                                return billItem.menuItem.categoryId == cateId;
                            })) {
                            tags.push(tag.name);
                        }
                    });
                    summary.items.push(item);
                    summary.tags = tags;
                    summary.dispatch = true;
                    data.push(summary);
                });
                if (bill.table.multiple) {
                    data.push(buildShippingSummary(bill, true));
                }
                if (rePrint) {
                    data.push(buildRePrintInfo(bill, "DisPatch"))
                }
                result.data = data;
                result.type = "DisPatch";
                return result;
            };

            var toOrderReceipt = PrinterConverterUtil.toOrderReceipt = function (bill, flag, woyou, type) {
                var result = {}, data = [];
                data.push({format: "title", value: POS.getCodeBytes(fullCode("order.receipt.title"))});
                data.push(buildBillHeader(bill));
                // 账单的科目项
                data.push(buildBillItemTable(bill, flag));
                // 只显示应收账单金额
                data.push(buildOrderSummary(bill, flag));
                if (bill.table.multiple) {
                    data.push(buildShippingSummary(bill));
                }
                if (bill.qrcode && bill.qrcode.length > 0 && !woyou) {
                    console.log(bill.qrcode);
                    var qrcodeList = [];
                    _.each(bill.qrcode, function (qrcode) {
                        qrcode.values = POS.getCodeBytes(fullCode("payment." + qrcode.type + ".label"));
                        qrcodeList.push(qrcode)
                    });
                    bill.qrcode = qrcodeList;
                    data.push(buildQrcode(bill))
                }
                if (type) {
                    data.push(buildRePrintInfo(bill, "Statement"));
                }
                let customerContent = buildCustomerContent();
                if (customerContent) {
                    data.push(buildLineFeed());
                    data.push(buildLineFeed());
                    data.push(buildLineFeed());
                    data.push(customerContent);
                }
                result.data = data;
                result.type = "Statement";
                return result;
            };

            var toCashierReceipt = PrinterConverterUtil.toCashierReceipt = function (bill, type) {
                var result = {}, data = [];
                data.push({format: "title", value: POS.getCodeBytes(fullCode("cashier.receipt.title"))});
                data.push(buildSerial(bill));
                data.push(buildBillHeader(bill));
                data.push(buildBillItemTable(bill));
                data.push(buildOrderSummary(bill));
                data.push(buildPayments(bill));
                if (bill.table.multiple) {
                    data.push(buildShippingSummary(bill));
                }
                let customerContent = buildCustomerContent();
                if (customerContent) {
                    data.push(buildLineFeed());
                    data.push(buildLineFeed());
                    data.push(buildLineFeed());
                    data.push(customerContent);
                }
                result.data = data;
                result.type = "Receipt";
                return result;
            };

            var openCashBox = PrinterConverterUtil.openCashBox = function () {
                var result = {}, data = [];
                result.data = "openbox";
                result.type = "Map";
                return result;
            };

            var printQrcode = PrinterConverterUtil.printQrcode = function (qrCode) {
                var result = {};
                result.data = qrCode;
                result.type = "Map";
                result.pType = "qrCode";
                return result;
            };

            var toBusinessRecord = PrinterConverterUtil.toBusinessRecord = function (bills, info) {
                var result = {}, data = [], summary, item, totals = [], user = POS.getUser(),
                    restaurant = DbRecorder.convert2JSON(POS.getRestaurant());
                data.push({format: "title", value: POS.getCodeBytes(fullCode("business.record.title.label"))});
                summary = {format: 'left_right_s', items: []};
                item = {
                    left: {value: POS.getCodeBytes(fullCode('restaurant.name.label'))},
                    right: {value: restaurant.bytesmap.name.valuebytes}
                };
                summary.items.push(item);
                item = {
                    left: {value: {text: info.startStr.substring(2)}},
                    right: {value: {text: info.endStr.substring(2)}}
                };
                summary.items.push(item);
                data.push(summary);
                var billCount = 0,
                    cashierBillCount = 0,
                    dinerCount = 0,
                    cashierDinerCount = 0,
                    orderAmount = 0,
                    cashierOrderAmount = 0,
                    paidAmount = 0,
                    cashierPaidAmount = 0,
                    discountedAmount = 0,
                    cashierDiscountedAmount = 0,
                    refundAmount = 0,
                    cashierRefundAmount = 0,
                    itemQuantity = 0,
                    cashierItemQuantity = 0,
                    refundQuantity = 0,
                    cashierRefundQuantity = 0,
                    payments = [], payment,
                    cashierPayments = [], cashierPayment;

                _.each(bills, function (bill) {
                    var originalShouldPay = 0;
                    _.each(bill.items, function (item) {
                        if (item.paid || !item.hasRefund) {
                            originalShouldPay += (item.price * item.quantity);
                        }
                    });
                    if (bill.refundStatus != "Total") {
                        if (bill.cashier && bill.cashier.username == user.username) {
                            cashierBillCount++;
                            cashierOrderAmount += originalShouldPay;
                            cashierPaidAmount += bill.paidAmount;
                            cashierDiscountedAmount += bill.offDiscountAmount;
                            cashierRefundAmount += bill.refundAmount;
                            _.each(bill.items, function (item) {
                                cashierItemQuantity += item.orderedQuantity;
                            });
                        }
                        billCount++;
                        dinerCount += bill.dinerCount;
                        orderAmount += originalShouldPay;
                        paidAmount += bill.paidAmount;
                        discountedAmount += bill.offDiscountAmount;
                        refundAmount += bill.refundAmount;
                        _.each(bill.items, function (item) {
                            itemQuantity += item.orderedQuantity;
                        });
                        _.each(bill.payments, function (p) {
                            if (p.method == 'WEIXIN' || p.method == 'WEIXIN_POS') {
                                p.method = 'WEIXIN';
                            }
                            if (p.method == 'ALIPAY' || p.method == 'ALIPAY_POS') {
                                p.method = 'ALIPAY';
                            }
                            if (bill.cashier && bill.cashier.username == user.username) {
                                cashierPayment = _.findWhere(cashierPayments, {method: p.method});
                                if (cashierPayment) {
                                    cashierPayment.amount += p.amount;
                                    cashierPayment.original += p.original;
                                } else {
                                    cashierPayments.push(_.clone(p));
                                }
                            }
                            payment = _.findWhere(payments, {method: p.method});
                            if (payment) {
                                payment.amount += p.amount;
                                payment.original += p.original;
                            } else {
                                payments.push(p);
                            }
                        });
                    } else if (bill.refundStatus == "Total") {
                        refundQuantity++;
                        if (bill.cashier && bill.cashier.username == user.username) {
                            cashierRefundQuantity++;
                        }
                    }
                });
                totals.push({key: "diner.total.count.label", value: dinerCount});
                totals.push({key: "bill.total.count.label", value: billCount});
                totals.push({key: "item.total.count.label", value: itemQuantity});
                totals.push({key: "received.pay.amount.label", value: paidAmount.toFixed(2)});
                totals.push({key: "bill.order.total.amount.label", value: orderAmount.toFixed(2)});
                totals.push({key: "refund.total.amount.label", value: refundAmount.toFixed(2)});
                totals.push({key: "offdiscounted.total.amount.label", value: discountedAmount.toFixed(2)});
                totals.push({key: "refund.total.item.count.label", value: refundQuantity});
                summary = {format: 'left_right_s', items: []};
                _.each(totals, function (total) {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode(total.key))},
                        right: {value: {text: total.value}}
                    };
                    summary.items.push(item);
                });
                data.push(summary);
                summary = {format: 'left_right_s', items: []};
                _.each(payments, function (payment) {
                    if (payment.amount != 0 && payment.method != "ROUND") {
                        var methodName = POS.getCodeBytes(fullCode("payment." + payment.method + ".label"));
                        if (payment.customPayment) {
                            methodName = payment.customPayment.bytesmap.name.valuebytes
                        }
                        item = {
                            left: {value: methodName},
                            right: {value: {text: payment.amount.toFixed(2)}}
                        };
                        summary.items.push(item);
                    }
                });
                data.push(summary);
                summary = {format: 'left_right_s', items: []};
                item = {
                    left: {value: POS.getCodeBytes(fullCode('operator.name.label'))},
                    right: {value: user.bytesmap.fullname ? user.bytesmap.fullname.valuebytes : user.bytesmap.name.valuebytes}
                };
                summary.items.push(item);
                data.push(summary);
                totals = [];
                totals.push({key: "bill.total.count.label", value: cashierBillCount});
                totals.push({key: "item.total.count.label", value: cashierItemQuantity});
                totals.push({key: "received.pay.amount.label", value: cashierPaidAmount.toFixed(2)});
                totals.push({key: "bill.order.total.amount.label", value: cashierOrderAmount.toFixed(2)});
                totals.push({key: "refund.total.amount.label", value: cashierRefundAmount.toFixed(2)});
                totals.push({key: "offdiscounted.total.amount.label", value: cashierDiscountedAmount.toFixed(2)});
                totals.push({key: "refund.total.item.count.label", value: cashierRefundQuantity});
                summary = {format: 'left_right_s', items: []};
                _.each(totals, function (total) {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode(total.key))},
                        right: {value: {text: total.value}}
                    };
                    summary.items.push(item);
                });
                data.push(summary);
                summary = {format: 'left_right_s', items: []};
                _.each(cashierPayments, function (payment) {
                    if (payment.amount != 0 && payment.method != "ROUND") {
                        var methodName = POS.getCodeBytes(fullCode("payment." + payment.method + ".label"))
                        if (payment.customPayment) {
                            methodName = payment.customPayment.bytesmap.name.valuebytes
                        }
                        item = {
                            left: {value: methodName},
                            right: {value: {text: payment.amount.toFixed(2)}}
                        };
                        summary.items.push(item);
                    }
                });
                data.push(summary);
                result.data = data;
                result.type = "BusinessRecord";
                return result;
            };

            var toSwitchItemReceipt = PrinterConverterUtil.toSwitchItemReceipt = function (billItem) {
                var user = POS.getUser();
                var result = {}, data = [], order, item, from = [], fromText = "", to = [], toText = "";
                data.push({format: "title", value: POS.getCodeBytes(fullCode("switch.item"))});
                order = {format: "left_right_s", items: []};
                item = {
                    left: {value: POS.getCodeBytes(fullCode('bill.sid'))},
                    right: {value: {text: billItem.sid}}
                };
                order.items.push(item);
                item = {
                    left: {font: "large", value: POS.getCodeBytes(fullCode('time.label'))},
                    right: {
                        font: "large",
                        value: {text: new moment().format('HH:mm')}
                    }
                };
                order.items.push(item);
                item = {
                    left: {font: "large", value: POS.getCodeBytes(fullCode("operator.name.label"))},
                    right: {
                        font: "large",
                        value: user.bytesmap.fullname ? user.bytesmap.fullname.valuebytes : user.bytesmap.name.valuebytes
                    }
                };
                order.items.push(item);
                var menuBytes = POS.getMenuItemBytes(billItem.menuItem.id).name.valuebytes;
                var quantity = {text: billItem.quantity};
                var unit = POS.getMenuItemBytes(billItem.menuItem.id);
                if (unit.itemUnit) {
                    var unitBytesMap = unit.itemUnit.valuebytes;
                    var text = "";
                    var bytes = [];
                    text += billItem.quantity.toString();
                    text += unitBytesMap.text;
                    _.each(billItem.quantity.toString(), function (code) {
                        bytes.push(code.charCodeAt(0));
                    });
                    bytes = bytes.concat(unitBytesMap.bytes);
                    quantity = {
                        text: text,
                        bytes: bytes
                    }
                }
                item = {
                    left: {font: "large", value: menuBytes},
                    right: {font: "large", value: quantity}
                };
                order.items.push(item);
                from = POS.getCodeBytes(fullCode('from')).bytes.concat(billItem.lastTable.bytesmap.name.valuebytes.bytes).concat(POS.getCodeBytes(fullCode('table')).bytes);
                to = POS.getCodeBytes(fullCode('to')).bytes.concat(billItem.targetTable.bytesmap.name.valuebytes.bytes).concat(POS.getCodeBytes(fullCode('table')).bytes);
                fromText = POS.getCodeBytes(fullCode('to')).text + billItem.lastTable.bytesmap.name.valuebytes.text + POS.getCodeBytes(fullCode('table')).text;
                toText = POS.getCodeBytes(fullCode('to')).text + billItem.targetTable.bytesmap.name.valuebytes.text + POS.getCodeBytes(fullCode('table')).text;
                item = {
                    left: {font: "large", value: {text: fromText, bytes: from}},
                    right: {font: "large", value: {text: toText, bytes: to}}
                };
                order.items.push(item);
                data.push(order);
                result.data = data;
                result.type = "Map";
                return result;
            };


            var toSwitchTableReceipt = PrinterConverterUtil.toSwitchTableReceipt = function (bill) {
                var user = POS.getUser();
                var result = {}, data = [], order, item, from = [], fromText = "", to = [], toText = "";
                data.push({format: "title", value: POS.getCodeBytes(fullCode("switch.table"))});
                order = {format: "left_right_s", items: []};
                item = {
                    left: {value: POS.getCodeBytes(fullCode('bill.sid'))},
                    right: {value: {text: sidText(bill)}}
                };
                order.items.push(item);
                item = {
                    left: {font: "large", value: POS.getCodeBytes(fullCode('time.label'))},
                    right: {
                        font: "large",
                        value: {text: bill.orderDate == 0 ? new moment().format('HH:mm') : new moment(bill.orderDate).format('HH:mm')}
                    }
                };
                order.items.push(item);
                item = {
                    left: {font: "large", value: POS.getCodeBytes(fullCode("operator.name.label"))},
                    right: {
                        font: "large",
                        value: user.bytesmap.fullname ? user.bytesmap.fullname.valuebytes : user.bytesmap.name.valuebytes
                    }
                };
                order.items.push(item);
                from = POS.getCodeBytes(fullCode('from')).bytes.concat(bill.lastTable.bytesmap.name.valuebytes.bytes).concat(POS.getCodeBytes(fullCode('table')).bytes);
                to = POS.getCodeBytes(fullCode('to')).bytes.concat(bill.targetTable.bytesmap.name.valuebytes.bytes).concat(POS.getCodeBytes(fullCode('table')).bytes);
                fromText = POS.getCodeBytes(fullCode('to')).text + bill.lastTable.bytesmap.name.valuebytes.text + POS.getCodeBytes(fullCode('table')).text;
                toText = POS.getCodeBytes(fullCode('to')).text + bill.targetTable.bytesmap.name.valuebytes.text + POS.getCodeBytes(fullCode('table')).text;
                item = {
                    left: {font: "large", value: {text: fromText, bytes: from}},
                    right: {font: "large", value: {text: toText, bytes: to}}
                };
                order.items.push(item);
                data.push(order);
                result.data = data;
                result.type = "Map";
                return result;
            };
            var toMembershipReceipt = PrinterConverterUtil.toMembershipReceipt = function (creditItem, status) {
                var result = {}, data = [], summary, item, totals = [],
                    restaurant = DbRecorder.convert2JSON(POS.getRestaurant());
                var type = status ? status : creditItem.operationType == "RECHARGE" ? "charge" : "spending";
                data.push({format: "title", value: POS.getCodeBytes(fullCode("membership." + type + ".tile.label"))});
                summary = {format: 'left_right_s', items: []};
                item = {
                    left: {value: POS.getCodeBytes(fullCode('restaurant.name.label'))},
                    right: {value: restaurant.bytesmap.name.valuebytes}
                };
                summary.items.push(item);
                item = {
                    left: {value: POS.getCodeBytes(fullCode('membership.no.label'))},
                    right: {value: creditItem.membership.bytesmap.cardNo.valuebytes}
                };
                summary.items.push(item);
                item = {
                    left: {value: POS.getCodeBytes(fullCode('membership.currency.label'))},
                    right: {value: creditItem.currency.bytesmap.name.valuebytes}
                };
                summary.items.push(item);
                if (creditItem.bytesmap.rechargeType) {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode('membership.recharge.label'))},
                        right: {value: POS.getCodeBytes(fullCode('charge.type.' + creditItem.bytesmap.rechargeType.value))}
                    };
                    summary.items.push(item);
                }
                totals.push({
                    key: "membership." + type + ".time.label",
                    value: new moment(creditItem.dateCreated).format('YYYY/MM/DD HH:mm')
                });
                totals.push({key: "membership.amount.before." + type + ".label", value: creditItem.amount.toFixed(2)});
                //totals.push({key: "membership.amount.after." + type + ".label", value: creditItem.credit.toFixed(2)});
                _.each(totals, function (total) {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode(total.key))},
                        right: {value: {text: total.value}}
                    };
                    summary.items.push(item);
                });
                if (creditItem.bytesmap.description) {
                    item = {
                        left: {value: POS.getCodeBytes(fullCode('note.label'))},
                        right: {value: creditItem.bytesmap.description.valuebytes}
                    };
                    summary.items.push(item);
                }
                data.push(summary);
                summary = {format: 'left_right_s', items: []};
                _.each(creditItem.membership.bytesmap.credit.valuebytes, function (credit) {
                    item = {
                        left: {value: credit.currency.valuebytes},
                        right: {value: credit.credit.valuebytes}
                    };
                    summary.items.push(item);
                });
                data.push(summary);
                result.data = data;
                result.type = "Map";
                return result;
            };

            return PrinterConverterUtil;
        }
    ).call(window);
};

let exportedValue = main($, _, Backbone, DbRecorder, i18n, POS);
export default exportedValue





// WEBPACK FOOTER //
// ./src/utils/PrinterConverterUtil.js